import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import Form from './Form'
import styled from 'styled-components'
import Footer from './Footer'

const Contact: React.FC = () => (
  <section id="footer">
    <div className="container">
      <header className="major">
        <h2>Contact</h2>
      </header>
      <Form name="contact" action="/submit/">
        <div className="row gtr-uniform">
          <div className="col-6 col-12-xsmall">
            <input
              type="text"
              name="name"
              id="name"
              required
              placeholder="Name"
            />
          </div>
          <div className="col-6 col-12-xsmall">
            <input
              type="email"
              name="email"
              id="email"
              required
              placeholder="Email"
            />
          </div>
          <div className="col-12">
            <textarea
              name="message"
              id="message"
              required
              placeholder="Message"
              rows={4}
            />
          </div>
          {process.env.GATSBY_SITE_RECAPTCHA_KEY && (
            <div className="col-12">
              <Wrapper>
                <ReCAPTCHA sitekey={process.env.GATSBY_SITE_RECAPTCHA_KEY} />
              </Wrapper>
            </div>
          )}
          <div className="col-12">
            <ul className="actions special">
              <li>
                <input type="submit" value="Send Message" className="primary" />
              </li>
            </ul>
          </div>
        </div>
      </Form>
    </div>
    <Footer />
  </section>
)

const Wrapper = styled.div`
  display: inline-block;
`

export default Contact
